module.exports = __webpack_public_path__ + "adba4626037a1db5087f28955910b518.png";